
function SbxApplication(applicationData) {
    let sbxApplication = applicationData || {};
    this.id = sbxApplication.id;
    this.name = sbxApplication.name;
    this.description = sbxApplication.descriptions;
    this.slogan = sbxApplication.slogans;
    this.url = sbxApplication.appUrl;
    this.logoUri = sbxApplication.logoUri;
    this.privacyPolicyUrl = sbxApplication.privacyPolicyUrl;
    this.termsOfServiceUrl = sbxApplication.termsOfServiceUrl;
    this.redirectUrl = sbxApplication.redirectUrl != null && sbxApplication.redirectUrl.length > 0 ? sbxApplication.redirectUrl[0] : undefined;
    this.creationDate = new Date(sbxApplication.creationDate);
    this.modificationDate = new Date(sbxApplication.modificationDate);
    this.type = sbxApplication.type;
}

module.exports = SbxApplication;